import { useEffect, useState } from "react";
import "../styles/HandWrite.css";
import PredictCanvas from "./PredictCanvas";
import TeachCanvas from "./TeachCanvas";

export default function HandWrite() {
  const [isTeaching, setIsTeaching] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="container">
      <button onClick={() => setIsTeaching(!isTeaching)} className="button">
        {isTeaching ? "予測モードに切替" : "教えるモードに切替"}
      </button>
      {isTeaching ? <TeachCanvas /> : <PredictCanvas />}
    </div>
  );
}
